// eslint-disable-next-line
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon, PageTitle } from '@pwc/pwc-deals-ui';
import { Modal } from 'react-bootstrap';
import CurrentlyMovingAnalysis from '../../models/CurrentlyMovingAnalysis';
import Group from '../../models/Group';
import { replaceGroupName } from '../../utils/groupsUtilities';
import { DefaultCustomUnGroupedNameI18nKey } from '../../models/constants';
import './MoveAnalysisModal.scss';

type Props = {
  show: boolean;
  setShow: (val: boolean) => void;
  confirm: (val: Group) => void;
  groups: Group[];
  itemToMove?: CurrentlyMovingAnalysis;
};

const MoveAnalysisModal: React.FC<Props> = ({
  show,
  setShow,
  confirm,
  groups,
  itemToMove,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className="move-analysis-modal"
      show={show}
      onHide={() => setShow(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <PageTitle title={t('moveToGroup')} size="h4" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content">
          {groups.map((group, i) => {
            if (itemToMove && group.groupId === itemToMove.moveFromGroupID)
              return null;

            return (
              <div key={group.title}>
                <Button
                  className="ui-button button-menu"
                  onClick={() => confirm(group)}
                  icon=""
                  iconClasses=""
                >
                  <Icon
                    name="move"
                    width="24"
                    className="sr2 outline icon-orange"
                  />
                  {group.groupId !== -1 && `${i + 1}. `}
                  {replaceGroupName(
                    group.groupId,
                    group.title,
                    t(DefaultCustomUnGroupedNameI18nKey)
                  )}
                </Button>
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MoveAnalysisModal;
